/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  /**
   * Отображение для страницы отписки от рассылки.
   */
  app.UnsubscribeView = app.View.extend({
    el: '.page_manager',
    events: {
      'click .scroll-to-rr': 'scrollToRR'
    },
    run: function () {
      var that = this;
      if (app.isDesktop) {
        $(window).on('scroll', that.scroller.bind(that));
      }
    },
    /**
     * Метод для анимации скролла с увеличением и размытием.
     */
    scroller: function () {
      var scrollTop = $(window).scrollTop(),
        stopAnimation = 800,
        filter = (scrollTop / stopAnimation) * 5,
        transform = ((scrollTop / stopAnimation) / 10) + 1,
        scrollable = this.$('.scrollablefixed');
      if (scrollTop < 0) {
        this.$('.scrollablefixed').css({filter: 'none', transform: 'scale(1.0)'});
      } else if (scrollTop < stopAnimation) {
        scrollable.css({filter: 'blur(' + filter + 'px)', transform: 'scale(' + transform + ')'});
      } else {
        scrollable.css({filter: 'blur(5px)', transform: 'scale(1.1)'});
      }
    },
    scrollToRR: function () {
      $('html, body').animate({
        scrollTop: $('.slide-retail').offset().top
      }, 'slow');
    }
  });
})(jQuery);

}.call(window));